<template>
  <b-dropdown
    variant="noop"
    toggle-class="no-padding"
    menu-class="dropdown-menu-anim"
    no-caret
    right
  >
    <template slot="button-content">
      <div class="kt-header__topbar-wrapper">
        <span class="kt-header__topbar-icon kt-header__topbar-icon--brand">
          <div
            class="flag-icon flag-header"
            :class="flag"
            style="display:inline-block"
            :title="$t('Change language')"
          ></div>
        </span>
      </div>
    </template>
    <b-dropdown-header>
      <strong style="font-size: 1rem;">{{$t('Change language')}}</strong>
    </b-dropdown-header>
    <b-dropdown-item class="kt-nav__link" @click="changeLang('ro')">
      <span class="kt-nav__link-icon">
        <div class="flag-icon flag-icon-ro item"></div>
      </span>
      <span class="kt-nav__link-text">{{ $t("Romanian") }}</span>
    </b-dropdown-item>
    <b-dropdown-item class="kt-nav__link" @click="changeLang('en')">
      <span class="kt-nav__link-icon">
        <div class="flag-icon flag-icon-gb item"></div>
      </span>
      <span class="kt-nav__link-text">{{ $t("English") }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "languageDropdown",
  data: () => {
    return {};
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    flag() {
      return this.lang == "en" ? "flag-icon-gb" : "flag-icon-ro";
    }
  },
  methods: {
    changeLang(l) {
      return this.$store.dispatch("global/setLanguage", l);
    }
  }
};
</script>
<style scoped>
.flag-icon.item {
  margin-right: 10px;
}
</style>

